import React from 'react';
import { colors } from '@guryou/colors';

const Pagination = ({ currentPage, totalPages, onPageChange, onPreviousPage, onNextPage, startIndex, endIndex, totalItems, className = '' }) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className={`mt-8 ${className}`}>
      {/* Pagination */}
      <div className="flex justify-center">
        <nav className="flex items-center space-x-2" aria-label="Pagination">
          {/* Previous Button */}
          <button
            onClick={onPreviousPage}
            disabled={currentPage === 1}
            className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
              currentPage === 1 ? `bg-[${colors.mercury}] text-[${colors.mineShaft}]` : `bg-[${colors.mandy}] text-white hover:bg-[${colors.cabaret}]`
            }`}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          {/* Page Numbers */}
          {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => {
            // Show first page, last page, current page, and pages around current page
            const showPage = page === 1 || page === totalPages || Math.abs(page - currentPage) <= 2;

            if (!showPage) {
              // Show ellipsis for gaps
              if (page === 2 && currentPage > 4) {
                return (
                  <span key={`ellipsis-${page}`} className="px-3 py-2 text-gray-500">
                    ...
                  </span>
                );
              }
              if (page === totalPages - 1 && currentPage < totalPages - 3) {
                return (
                  <span key={`ellipsis-${page}`} className="px-3 py-2 text-gray-500">
                    ...
                  </span>
                );
              }
              return null;
            }

            return (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  currentPage === page
                    ? `text-white bg-[${colors.mandy}]`
                    : `text-gray-700 hover:text-white hover:bg-[${colors.mandy}] border border-[${colors.mercury}]`
                }`}
              >
                {page}
              </button>
            );
          })}

          {/* Next Button */}
          <button
            onClick={onNextPage}
            disabled={currentPage === totalPages}
            className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
              currentPage === totalPages
                ? `bg-[${colors.mercury}] text-[${colors.mineShaft}]`
                : `bg-[${colors.mandy}] text-white hover:bg-[${colors.cabaret}]`
            }`}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </nav>
      </div>

      {/* Pagination Info */}
      <div className="mt-4 text-center">
        <p className="text-sm text-gray-600">
          Mostrando {startIndex + 1} - {Math.min(endIndex, totalItems)} de {totalItems} resultados
        </p>
      </div>
    </div>
  );
};

export default Pagination;
